export enum AccessType {
	Other	= 0,
	Metro	= 1,
	Rer		= 2,
	Tramway	= 3
}